<div class="orders-page">

  <!-- HEADER -->
  <div class="header">

    <p class="mini-title">
      {{ t('userDashboard') }}
    </p>

    <h1>
      {{ t('myOrdersTitle') }}
    </h1>

    <span>
      {{ t('trackRecentPurchases') }}
    </span>

  </div>

  <!-- LOADING -->
  <div
    class="loading-box"
    *ngIf="loading"
  >
    {{ t('loadingOrders') }}
  </div>

  <!-- EMPTY -->
  <div
    class="empty-box"
    *ngIf="!loading && orders.length === 0"
  >
    <i class="fa-solid fa-box-open"></i>
    <h3>{{ t('noOrdersYet') }}</h3>
    <p>{{ t('startShoppingNow') }}</p>
  </div>

  <!-- ORDERS -->
  <div class="orders">

    <div
      class="card"
      *ngFor="let o of orders"
    >

      <!-- TOP -->
      <div class="top">

        <!-- LEFT -->
        <div>

          <h2>
            {{ t('orderNumber') }} #{{o.id}}
          </h2>

          <div class="meta">

            <p>👤 {{o.name}}</p>

            <p>📞 {{o.phone}}</p>

            <p>📍 {{o.address || t('noAddressSelected')}}</p>

            <p *ngIf="mapLink(o)">
              <a
                class="map-link"
                [href]="mapLink(o)"
                target="_blank"
                rel="noopener"
              >
                <i class="fa-solid fa-map-location-dot"></i>
                {{ t('viewOnMap') }}
              </a>
            </p>

          </div>

        </div>

        <!-- RIGHT -->
        <div class="top-right">

          <div
            class="status"
            [ngClass]="o.status"
          >
            {{ statusLabel(o.status) }}
          </div>

          <button
            class="delete-btn"
            (click)="deleteOrder(o.id)"
          >
            {{ t('delete') }}
          </button>

        </div>

      </div>

      <!-- INFO -->
      <div class="info-grid">

  <div class="info-box">
    <span>{{ t('totalAmountLabel') }}</span>
    <h3>
      {{ o.totalAmount | bnNumber:'৳ ' }}
    </h3>
  </div>

  <div class="info-box">
    <span>{{ t('paidAmountLabel') }}</span>
    <h3 style="color:green">
      {{ (o.paidAmount || o.totalAmount || 0) | bnNumber:'৳ ' }}
    </h3>
  </div>

  <div class="info-box">
    <span>{{ t('paymentLabel') }}</span>
    <h3
      [ngClass]="{
        'bkash': o.paymentMethod === 'BKASH',
        'nogod': o.paymentMethod === 'NAGAD'
      }"
    >
      {{ o.paymentMethod }}
    </h3>
  </div>

</div>

      <!-- ORDER ITEMS -->
      <div
        class="items-section"
        *ngIf="o.items?.length"
      >

        <h4>
          {{ t('orderedProducts') }}
        </h4>

        <div
          class="item"
          *ngFor="let item of o.items"
        >

          <div class="item-left">

            <p class="product-name">
              {{item.productName}}
            </p>

            <span class="product-price">
              {{ item.price | bnNumber:'৳ ' }}
            </span>

          </div>

          <span class="qty">
            x{{ item.quantity | bnNumber }}
          </span>

        </div>

      </div>

      <!-- DATE -->
      <div class="date">
        📅 {{ t('placedOn') }}: {{o.createdAt | date:'medium'}}
      </div>

    </div>

  </div>

</div>
